import getRemBase from 'propel/getRemBase';

const setHeaderHeight = () => {
	const header = document.querySelector('.main-header');
	const headerWrapper = document.querySelector('.header-wrapper');
	const adminBar = document.getElementById('wpadminbar');

	const headerHeight = header ? header.offsetHeight : 0;
	const headerWrapperHeight = headerWrapper ? headerWrapper.offsetHeight : 0;
	const adminBarHeight = adminBar ? adminBar.offsetHeight : 0;

	document.body.style.setProperty(
		'--header-height',
		`${(headerHeight + adminBarHeight) / getRemBase()}rem`
	);

	// How far a block has to be pushed down to sit flush under the fixed header,
	// measured from the whole wrapper so any alert bar above the navigation is
	// included. The document is already offset by the margin-top core puts on
	// html for the admin bar, while the header is fixed to the viewport and
	// ignores that margin — so it has to come back out here, or logged-in views
	// gain a gap the exact height of the admin bar. Only meaningful where the
	// header is fixed (lg and up); below that it is sticky and holds its own
	// space, so no clearance is needed.
	const documentOffset =
		parseFloat(getComputedStyle(document.documentElement).marginTop) || 0;

	document.body.style.setProperty(
		'--header-clearance',
		`${Math.max(headerWrapperHeight - documentOffset, 0) / getRemBase()}rem`
	);
};

export default setHeaderHeight;
